/*!
 * Glance Digital Custom JavaScript Programing
 * lance@glance.ca
 *
 */

jQuery(document).ready(function ($) {
  // SETTINGS
  // ------------------

  // Velocty Easing
  // ------

  $.Velocity.defaults.easing = "easeInOutQuart";

  // PLUGINS
  // ------------------

  // Greenhouse posts list

  if ($('#greenhouse-posts').length) {
    $('#greenhouse-posts').greenhousePosts();
  }

  if ($('#latest-greenhouse-jobs').length) {
    $('#latest-greenhouse-jobs').greenhouseLatest();
  }
  
  if ($('#greenhouse-jobs-sidebar').length) {
    $('#greenhouse-jobs-sidebar').greenhouseSidebar();
  }

  // Top Header Nav

  if ($(".site-header").length) {
    $(".site-header").switchNav();
  }

  // Anchor Link Scroll
  $("a[href^='#']").scrollto({ offset_lg: 130, offset_sm: 120 });


  // Body Background Switcher
  // if ($("section[data-bodycolor]").length) {
  // $("section[data-bodycolor]").bodyColorSwitcher();
  // }
  $(".bg-grey, .bg-black").each(function () {
    $(this).one("inview", function (event, isInView) {
      if (isInView) {
        $(this).addClass("infocus");
      }
    });
  });

  // Image Carousel
  if ($(".module-image-carousel .swiper-slide").length > 1) {
    $(".module-image-carousel").each(function () {
      $(this).gallery({
        slidesPerView: 1,
      });
    });
  }
  
  // Two Column Image Carousel
  if ($(".module-two-column .swiper-slide").length > 1) {
    $(".module-two-column").each(function () {
      $(this).gallery({
        slidesPerView: 1,
      });
    });
  }

  // Three Column Post Carousel
  if ($(".module-three-column-post-carousel .swiper-slide").length > 1) {
    $(".module-three-column-post-carousel").each(function () {
      $(this).gallery();
    });
  }

  // Product Applications Carousel -- Default page
  if ($(".site-content > article > .module-product-applications .applications .swiper-slide").length > 1) {
    $(".module-product-applications").each(function () {
      var applicationsGallery = $(this).find(".applications").gallery({
        centered: true,
        smallSlidesPerView: 1,
      });

      $(this).find(".applications li").productApplicationsGalleryControl();

      $(this).productApplications({
        gallery: applicationsGallery,
        breakpoint: "atleast_large",
      });
    });
  }

  // Product Applications Carousel -- Sidebar page
  if ($(".site-content > article > .body-two-columns > .body-content > .module-product-applications .applications .swiper-slide").length > 1) {
    $(".module-product-applications").each(function () {
      var applicationsGallery = $(this).find(".applications").gallery({
        centered: true,
        smallSlidesPerView: 1,
        smallBreakpoint: 1200,
        breakpoint: 1500
      });

      $(this).find(".applications li").productApplicationsGalleryControl();

      $(this).productApplications({
        gallery: applicationsGallery,
        breakpoint: "atleast_xlarge",
      });
    });
  }

  // Thought Leadership Carousel
  if ($(".module-topic-gallery .swiper-slide").length > 1) {
    $(".module-topic-gallery").each(function () {
      $(this).gallery({
        centered: true,
      });
    });
  }

  // Product Tour (Product Hero)
  if ($(".module-product-hero.has-tour").length) {
    $(".module-product-hero.has-tour").each(function () {
      $(this).productTour({
        btn: $(this).find("#product-tour, #tour-close"),
      });
    });
  }

  // Produt Tour (Module) 
  if ($(".module-product-tour").length) {
    $(".module-product-tour").each(function () {
      $(this).productTour();
    });
  }

  // Vertical Slider
  if ($(".module-vertical-two-column-slider .swiper-slide").length > 1) {
    $(".module-vertical-two-column-slider .content-flow").each(function () {
      $(this).galleryVerticalMobile();
    });
    $(".module-vertical-two-column-slider .large-image-container").each(
      function () {
        $(this).galleryVerticalDesktop();
      }
    );
  }

  if ($(".feature-categories-list .feature-category").length) {
    $(".feature-categories-list .feature-category").featureCategories();
  }

  // Ajax load more

  if ($("#postslist.posts-list").length) {
    $("#postslist.posts-list").ajaxLoad();
  }

  if ($("#postslist.leadership-list").length) {
    $("#postslist.leadership-list").ajaxFilter({
      post_type: "c_person",
      template: "parts/loop-leadership.php",
    });
  }

  if ($("#postslist.job-list").length) {
    $(".category-filter-multi-container .toggle-filter").filterToggle({
      container: ".category-filter-multi",
    });

    $("#postslist.job-list").ajaxFilter({
      post_type: "c_job",
      template: "parts/loop-job.php",
      filter: ".category-filter-multi",
      multi: true,
    });
  }

  if ($(".category-filter").length) {
    $(".category-filter").highlightSiblings();
  }

  // Sticky Block
  if ($(".sidebar .sections").length) {
    $(".sidebar .sections").stickyBlock();
  }

  // Sticky Header
  if ($(".thought-category-sticky-titles").length) {
    $(".thought-category-sticky-titles").stickyHeader();
  }

  // Sidebar sections
  if ($(".sidebar .section-toggle").length) {
    $(".sidebar .section-toggle").sidebarSectionToggle();
  }

  // Side Form
  if ($(".side-form").length) {
    $(".side-form").sideForm();
  }

  // Popup Form
  if ($("button[data-form]").length) {
    $("button[data-form]").popupForm();
  }

  // FAQ
  if ($(".module-faqs .faq").length) {
    $(".module-faqs .faq").faq();
  }

  // Mapbox
  if ($("#map").length) {
    $("#map").mapbox();
  }

  if ($(".parallaxHorizontal").length) {
    $(".parallaxHorizontal").each(function () {
      var $this = $(this);
      $this.parallaxFG({
        offsetIntertia: $this.data("inertia"),
        axis: "x",
        breakpoint: $this.data("parallaxbreakpoint"),
      });
    });
  }

  if ($(".cta-quote").length) {
    $(".cta-quote").each(function () {
      var $this = $(this);
      $this.parallaxFG({
        offsetIntertia: -0.075,
        breakpoint: "atleast_large",
      });
    });
  }

  // Show in View (inview-animate.js)

  if ($(".showOnView").length) {
    $(".showOnView").showOnView();
  }

  if ($("body.load-delay").length) {
    setTimeout(function () {
      $("body").removeClass("load-delay");
    }, 1000);
  }

  // Quote Video Play

  if ($(".quote .video-container").length) {
    $(".quote .video-container").each(function () {
      $(this).quoteVideo();
    });
  }

  // Init Breakpoint Listeners
  // ------------------

  $(this).breakpoints();
});

// ------------------------------------------------------------------------------------------------------------------------------------------------
// PLUGINS

(function ($) {
  

  //
  // Gallery
  //

  $.fn.gallery = function (options) {
    var settings = $.extend(
      {
        smallBreakpoint: 1040,
        breakpoint: 1200,
        slidesPerView: 3,
        smallSlidesPerView: null,
        initialize: false,
        centered: false,
      },
      options
    );
    var $this = this;
    var gallery = null;
    var smallSlidesPerView =
      settings.slidesPerView > 1 ? settings.slidesPerView - 1 : 1;
    smallSlidesPerView = settings.smallSlidesPerView
      ? settings.smallSlidesPerView
      : smallSlidesPerView;

    var id = this.find(".swiper-container").length
      ? this.find(".swiper-container").attr("id")
      : null;

    if (id) {
      gallery = new Swiper("#" + id, {
        observer: settings.initialize,
        observeParents: settings.initialize,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: settings.centered,
        pagination: {
          el: ".pagination .swiper-pagination",
          clickable: true,
        },

        navigation: {
          nextEl: ".pagination .swiper-button-next, .slide-next",
          prevEl: ".pagination .swiper-button-prev, .slide-prev",
        },
        breakpoints: {
          [settings.smallBreakpoint]: {
            slidesPerView: smallSlidesPerView,
          },
          [settings.breakpoint]: {
            slidesPerView: settings.slidesPerView,
          },
        },
      });

      gallery.on("transitionEnd", function () {
        $.publish("gallerySlideChange", [
          {
            activeIndex: $this
              .find(".swiper-slide-active")
              .attr("data-swiper-slide-index"),
          },
        ]);
      });
      setTimeout(function () {
        $.publish("gallerySlideChange", [
          {
            activeIndex: $this
              .find(".swiper-slide-active")
              .attr("data-swiper-slide-index"),
          },
        ]);
      }, 300);

      $.subscribe("galleryNav", function (obj, navigation) {
        gallery.slideToLoop(navigation.index);
      });
    }

    return gallery;
  };

  $.fn.productApplicationsGalleryControl = function (options) {
    var settings = $.extend(
      {
        offset: 0,
      },
      options
    );

    var $all = this;
    this.on("click", function () {
      $.publish("galleryNav", [{ index: $(this).index() + settings.offset }]);
    });

    function activate(index) {
      $all.removeClass("active");
      if (index - settings.offset >= 0) {
        $all.eq(index - settings.offset).addClass("active");
      }
    }

    $.subscribe("gallerySlideChange", function (obj, state) {
      activate(state.activeIndex);
    });

    activate(0);
  };

  $.fn.productApplications = function (options) {
    var settings = $.extend(
      {
        gallery: null,
        breakpoint: "atleast_large",
        nav_desk: ".nav-desktop",
      },
      options
    );

    var $this = this;
    var $nav_desk = $(settings.nav_desk);

    this.on("click", ".cta button", function () {
      $this.toggleClass("active");
      if (settings.gallery) {
        settings.gallery.slideToLoop(0);
      }
    });

    function addNavSlide() {
      if (settings.gallery && !$this.find(".nav-mobile").length) {
        settings.gallery.prependSlide(
          '<div class="swiper-slide"><div class="slide nav-mobile">' +
            $nav_desk.html() +
            "</div></div>"
        );
        $this
          .find(".nav-mobile li")
          .productApplicationsGalleryControl({ offset: 1 });
      }
    }

    function removeNavSlide() {
      if (settings.gallery && $this.find(".nav-mobile").length) {
        $this.find(".nav-mobile li").off("click");
        settings.gallery.removeSlide(0);
      }
    }

    function toggleNavSlide(obj, media) {
      // Set Desktop
      if (media[settings.breakpoint]) {
        removeNavSlide();

        // Set Mobile
      } else {
        addNavSlide();
      }
    }
    $.subscribe("breakpoints", toggleNavSlide);
  };

  //
  // Vertical Gallery
  //

  $.fn.galleryVerticalMobile = function (options) {
    var settings = $.extend(
      {
        breakpoint: "atleast_large",
        initialize: false,
      },
      options
    );
    var gallery = null;

    var id = this.find(".swiper-container").length
      ? this.find(".swiper-container").attr("id")
      : null;

    function initGallery() {
      if (id) {
        gallery = new Swiper("#" + id, {
          observer: settings.initialize,
          observeParents: settings.initialize,
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: ".pagination .swiper-pagination",
            clickable: true,
          },
        });
      }
    }

    function toggleGallery(obj, media) {
      // Set Desktop gallery
      if (media[settings.breakpoint] || media.fallback) {
        if (gallery != null) {
          gallery.destroy(true, true);
          gallery = null;
        }

        // Set Mobile gallery
      } else {
        if (gallery == null) {
          initGallery();
        }
      }
    }
    $.subscribe("breakpoints", toggleGallery);

    return this;
  };

  $.fn.galleryVerticalDesktop = function (options) {
    var settings = $.extend(
      {
        breakpoint: "atleast_large",
        initialize: false,
      },
      options
    );
    var gallery = null;

    var id = this.find(".swiper-container").length
      ? this.find(".swiper-container").attr("id")
      : null;

    var $window = $(window);
    var $header = $(".site-header");
    var $el = this;
    var $container = $el.parent();
    var $form = $container.find(".content-flow");
    var offset = $header.outerHeight();

    function initGallery() {
      if (id) {
        gallery = new Swiper("#" + id, {
          observer: settings.initialize,
          observeParents: settings.initialize,
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          allowTouchMove: false,
          pagination: {
            el: ".pagination .swiper-pagination",
            clickable: false,
            renderBullet: function (index, className) {
              return (
                '<span class="' + className + '">0' + (index + 1) + "</span>"
              );
            },
          },
        });
      }
    }

    function toggleGallery(obj, media) {
      // Set Desktop gallery
      if (media[settings.breakpoint] || media.fallback) {
        if (gallery == null) {
          initGallery();
        }

        // Set Mobile gallery
      } else {
        if (gallery != null) {
          gallery.destroy(true, true);
          gallery = null;
        }
      }
    }
    $.subscribe("breakpoints", toggleGallery);

    $window.on("resize", function () {
      updateStickyBlock();
    });

    $window.on("scroll", function () {
      updateStickyBlock();
    });

    function checkConditions() {
      return $el.is(":visible");
    }

    function updateStickyBlock() {
      var ok = checkConditions();
      if (ok) {
        offset = $header.outerHeight();

        var i = $form.find(".swiper-slide").length;

        while (i--) {
          var $i = $form.find(".swiper-slide").eq(i);
          if (gallery && isInFocus($i, 0.75)) {
            gallery.slideTo(i);
            break;
          }
        }

        // $form.find(".swiper-slide").each(function () {
        //   var $i = $(this);
        //   if (isInFocus($i, 0.75)) {
        //   }
        // });

        if (
          $window.scrollTop() > $form.offset().top - offset &&
          $window.scrollTop() + offset <
            $form.offset().top + ($form.outerHeight() - $el.outerHeight())
        ) {
          $el.attr(
            "style",
            "position: fixed; top:" +
              offset +
              "px; left:" +
              $container.offset().left +
              "px; width:" +
              $container.outerWidth() +
              "px;"
          );
        } else if (
          $window.scrollTop() + offset >=
          $form.offset().top + ($form.outerHeight() - $el.outerHeight())
        ) {
          $el.attr(
            "style",
            "position: absolute; top:" +
              ($form.outerHeight() - $el.outerHeight()) +
              "px;"
          );
        } else {
          $el.attr("style", "");
        }
      } else {
        $el.attr("style", "");
      }
    }

    return this;
  };

  //
  // Product Tour
  //

  $.fn.productTour = function (options) {
    var settings = $.extend(
      {
        btn: null,
        breakpoint: "atleast_large",
        initialize: false,
      },
      options
    );

    var $container = this;
    var gallery = null;
    var is_desktop = true;
    var id = this.find(".swiper-container").length
      ? this.find(".swiper-container").attr("id")
      : null;

    function initGallery() {
      if (id) {
        gallery = new Swiper("#" + id, {
          observer: settings.initialize,
          observeParents: settings.initialize,
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: ".pagination .swiper-pagination",
            clickable: true,
          },
        });
      }
    }

    function onBreakpoint(obj, media) {
      is_desktop = media[settings.breakpoint] || media.fallback;
      toggleGallery();
    }

    function toggleGallery() {
      // Set Desktop gallery
      if (is_desktop) {
        if (gallery != null) {
          gallery.destroy(true, true);
          gallery = null;
        }

        // Set Mobile gallery
      } else {
        if (gallery == null) {
          initGallery();
        }
      }
    }

    if (settings.btn) {
      settings.btn.on("click", function () {
        $container.toggleClass("tour-open");
      });
    }

    $.subscribe("breakpoints", onBreakpoint);
  };


  //
  // Body Color Switcher
  //

  $.fn.bodyColorSwitcher = function () {
    var $el = this;
    var $body = $("body");

    function updateBodyColor() {
      $el.each(function () {
        var $i = $(this);
        if (isInFocus($i, 0.6)) {
          $body
            .removeClass("bg-grey bg-white")
            .addClass("bg-" + $i.data("bodycolor"));
        }
      });
    }

    $(window)
      .on("scroll", $.throttle(250, updateBodyColor))
      .on("resize", $.throttle(250, updateBodyColor));
  };

  // 
  // Greenhouse Posts List
  // 

  $.fn.greenhousePosts = function () {
    const url = 'https://boards-api.greenhouse.io/v1/boards/aperaaiinc/jobs?content=true';

    fetch(url)
    .then(res => res.json())
    .then(out => {
      const jobs = out.jobs;
      const jobsList = document.querySelector('#greenhouse-posts');

      // sort jobs by date
      jobs.sort(function(a, b) {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });

      for (let i = 0; i < jobs.length; i++) {
        buildJob(jobs[i], jobsList);
      }
    })
    .catch(err => { throw err });

    function buildJob(job, jobsList) {
      const link = job.absolute_url;
      const title = job.title;
      const department = job.departments[0].name;
      const date = formatDate(job.updated_at);
      const description = parseDescription(job.content);

      const content = hydrateJobTemplate({
        link: link,
        title: title,
        department: department,
        date: date,
        description: description
      });

      jobsList.appendChild( content );
    }

    function formatDate(date) {
      const dateObj = new Date(date);
      const dateFormatted = dateObj.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      return dateFormatted;
    }

    function parseDescription(description) {
      const parser = new DOMParser();
      const html = parser.parseFromString(description, 'text/html');
      const div = document.createElement("div");
      
      div.innerHTML = html.documentElement.textContent;

      // remove intro from div
      if (div.querySelector(".content-intro")) {
        div.querySelector(".content-intro").remove();
      }

      // remove all headings from div
      const headings = div.querySelectorAll("h1, h2, h3, h4, h5, h6");
      for (let i = 0; i < headings.length; i++) {
        headings[i].remove();
      }

      // search the div for the string "Job description" and remove it
      var searchValue = "Job description";
      if(div.innerHTML.indexOf(searchValue) != -1){
        div.innerHTML = div.innerHTML.replace(searchValue, "");
      }
      
      const core = div.querySelector(".core-paragraph p") ? div.querySelector(".core-paragraph p") : div;
      const core_str = core.textContent || core.innerText || "";
      const core_truncated_str = truncateString(core_str, 250);
      
      return core_truncated_str;
    }

    function truncateString(str, num) {
      if (str.length <= num) {
        return str
      }
      return str.slice(0, num) + '...'
    }

    function hydrateJobTemplate(data) {
      const template = document.getElementById('job-template');
      const clone = template.firstElementChild.cloneNode(true);
      const link = clone.querySelector('.tile');
      const title = clone.querySelector('.job-title');
      const department = clone.querySelector('.department');
      const date = clone.querySelector('.date-posted');
      const description = clone.querySelector('.job-description');

      link.href = data.link;
      title.textContent = data.title;
      department.textContent = data.department;
      date.textContent = data.date;
      description.textContent = data.description;

      return clone;
    }
  };

  // Latest Greenhouse Jobs
  $.fn.greenhouseLatest = function () {
    const url = 'https://boards-api.greenhouse.io/v1/boards/aperaaiinc/jobs';

    fetch(url)
    .then(res => res.json())
    .then(out => {
      let jobs = out.jobs;
      const jobsList = document.querySelector('#latest-greenhouse-jobs');

      // sort jobs by date
      jobs.sort(function(a, b) {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });

      // limit to 3 jobs
      jobs = jobs.slice(0, 3);

      for (let i = 0; i < jobs.length; i++) {
        buildJob(jobs[i], jobsList);
      }

      function buildJob(job, jobsList) {
        const link = job.absolute_url;
        const title = job.title;
        const date = formatDate(job.updated_at);
  
        const content = hydrateJobTemplate({
          link: link,
          title: title,
          date: date
        });
  
        jobsList.insertAdjacentHTML( 'beforeend', content );
      }

      function formatDate(date) {
        const dateObj = new Date(date);
        const dateFormatted = dateObj.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        return dateFormatted;
      }

      function hydrateJobTemplate(data) {
        const template = `<li>
          <a class="tile" href="${ data.link }">
            <h6>${ data.date }</h6>
            <h2>${ data.title }</h2>
          </a>
        </li>`;
        return template;
      }
    })
    .catch(err => { throw err });
  };
  
  // Sidebar Greenhouse Jobs
  $.fn.greenhouseSidebar = function () {
    const url = 'https://boards-api.greenhouse.io/v1/boards/aperaaiinc/jobs';

    fetch(url)
    .then(res => res.json())
    .then(out => {
      let jobs = out.jobs;
      const jobsList = document.querySelector('#greenhouse-jobs-sidebar');

      // sort jobs by date
      jobs.sort(function(a, b) {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });

      // limit to 3 jobs
      jobs = jobs.slice(0, 3);

      for (let i = 0; i < jobs.length; i++) {
        buildJob(jobs[i], jobsList);
      }

      function buildJob(job, jobsList) {
        const link = job.absolute_url;
        const title = job.title;
        const date = formatDate(job.updated_at);
  
        const content = hydrateJobTemplate({
          link: link,
          title: title,
          date: date
        });
  
        jobsList.insertAdjacentHTML( 'beforeend', content );
      }

      function formatDate(date) {
        const dateObj = new Date(date);
        const dateFormatted = dateObj.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        return dateFormatted;
      }

      function hydrateJobTemplate(data) {
        const template = `<li class="item">
          <a class="tile" href="${ data.link }">
            <h6>${ data.date }</h6>
            <h4>${ data.title }</h4>
          </a>
        </li>`;
        return template;
      }
    })
    .catch(err => { throw err });
  };

  // Top Navigation : toggle mobile and desktop
  // ------

  $.fn.switchNav = function (options) {
    var settings = $.extend(
      {
        breakpoint: "atleast_large",
      },
      options
    );

    var $top = this;
    var nav_desk = $top.desktopMenu();
    var nav_mobile = null;

    function switchNav(obj, media) {
      // Set Desktop Nav
      if (media[settings.breakpoint] || media.fallback) {
        if (nav_mobile != null) {
          nav_mobile.kill();
          nav_mobile = null;
        }

        // Set Mobile Nav
      } else {
        if (nav_mobile == null) {
          nav_mobile = $top.mobileMenu();
        }
      }
    }
    $.subscribe("breakpoints", switchNav);
  };

  // Mobile Menu

  $.fn.mobileMenu = function () {
    var $container = this;
    var $body = $("body");
    var $navWrapper = $container.find(".topNavWrapper");
    var $nav = $navWrapper.find(".topNav");
    var $links = $nav.find("> ul > li > a");
    var $primaryDropdown = this.find(".hamburger");
    var $subnav = $nav.find(".sub-menu");

    $navWrapper.velocity("slideUp", { duration: 0, display: "none" });

    $primaryDropdown.on("click", function (e) {
      e.preventDefault();
      if ($body.hasClass("header-open")) {
        $primaryDropdown.removeClass("is-active");
        $body.removeClass("header-open");
        $navWrapper.velocity("transition.slideUpOut", {
          duration: 300,
          display: "none",
        });
        $links.velocity("transition.slideLeftOut", {
          duration: 200,
          display: "none",
        });
      } else {
        $primaryDropdown.addClass("is-active");
        $body.addClass("header-open");
        $navWrapper.velocity("transition.slideDownIn", {
          duration: 300,
          display: "flex",
        });
        $links.velocity("transition.slideLeftIn", {
          // stagger: 100,
          duration: 300,
          display: "block",
        });
        $navWrapper.scrollTop(0);
        $subnav.removeClass("open");
      }
    });

    $subnav.on("click", function () {
      $(this).toggleClass("open");
    });

    return {
      kill: function () {
        $primaryDropdown.off("click").removeClass("is-active");
        $body.removeClass("header-open");
        $navWrapper.velocity("slideDown", {
          duration: 0,
          display: "flex",
          complete: function () {
            $navWrapper.attr("style", "");
          },
        });
        $links.velocity("slideDown", {
          duration: 0,
          display: "block",
          complete: function () {
            $links.attr("style", "");
          },
        });
        $subnav.find("li").velocity("slideDown", {
          duration: 0,
          display: "block",
          complete: function () {
            $subnav.attr("style", "");
          },
        });
      },
    };
  };

  // Desktop Menu

  $.fn.desktopMenu = function (options) {
    var settings = $.extend(
      {
        trigger_offset: 70,
      },
      options
    );

    var $container = this;
    var $window = $(window);
    var $body = $("body");
    var scrollTop = $window.scrollTop();
    var min = false;
    var $related_links = $(".main-menu-related-links");

    $related_links.each(function () {
      var $el = $(this);
      var name = $el.data("name");
      if ($container.find("." + name + " .sub-menu").length) {
        var $sub = $container.find("." + name + " .sub-menu");
        $sub.addClass("has-related-links");
        $sub.append("<li class='related-links'></li>");
        $sub.find(".related-links").append($el);
      }
    });

    function scrollState() {
      scrollTop = $window.scrollTop();

      // Minimized Top State
      if (scrollTop >= settings.trigger_offset && !min) {
        min = true;
        $body.addClass("header-minimize");

        // Full Top State
      } else if (scrollTop < settings.trigger_offset && min) {
        min = false;
        $body.removeClass("header-minimize");
      }
    }

    $window.on("scroll.menustate", scrollState);
    scrollState();

    // Kill desktop functionality
    // ------

    return {
      kill: function () {
        $body.removeClass("header-minimize");
        $window.off("scroll.menustate");
      },
    };
  };

  // Anchor scroll
  // ------

  $.fn.scrollto = function (options) {
    var settings = $.extend(
      {
        offset_lg: 0,
        offset_sm: 0,
        exclude: "tabbed-link",
      },
      options
    );

    var offset = settings.offset_lg;

    $.subscribe("breakpoints", function (obj, media) {
      offset = media.atleast_large ? settings.offset_lg : settings.offset_sm;
    });

    this.on("click", function (event) {
      var id = $(this).attr("href").split("#")[1];

      if ($("#" + id).length && !$(this).hasClass(settings.exclude)) {
        event.preventDefault();

        var $el = $("#" + id);
        var top = id == "top" ? $el.offset().top : $el.offset().top - offset;
        $("html").velocity("scroll", { duration: 900, offset: top });
      }
    });

    return this;
  };
  
  $.fn.scrolltobtn = function (options) {
    var settings = $.extend(
      {
        offset_lg: 0,
        offset_sm: 0,
      },
      options
    );

    var offset = settings.offset_lg;

    $.subscribe("breakpoints", function (obj, media) {
      offset = media.atleast_large ? settings.offset_lg : settings.offset_sm;
    });

    this.on("click", function () {
      var id = $(this).data("target");
      if ($("#" + id).length) {
        var $el = $("#" + id);
        var top = id == "top" ? $el.offset().top : $el.offset().top - offset;
        $("html").velocity("scroll", { duration: 900, offset: top });
      }
    });

    return this;
  };



  // Ajax load more posts
  // ------

  $.fn.ajaxLoad = function (options) {
    var settings = $.extend(
      {
        url: "",
        post_type: "post",
        template: "parts/loop-archive.php",
        page_action: "posts_load",
        paginate: "#paginateNav",
        post: ".ajax-post",
        posts_per_page: "posts_per_page",
        filter: ".category-filter",
      },
      options
    );

    var $container = this;
    var $paginateNav = $container.next(settings.paginate);
    var pageIsLoading = false;
    var postsPerPage = this.data(settings.posts_per_page);
    var $filter = $(settings.filter);
    var filter_str = "";
    var prefix = settings.url != "" ? "/" + settings.url : "";

    $paginateNav.on("click.ajaxload", "a", function (e) {
      e.preventDefault();
      updateFilter();
      ajaxLoad("paginate");
    });

    $filter.on("click", "a", function (e) {
      e.preventDefault();

      $(this)
        .addClass("selected")
        .parent()
        .siblings()
        .find("a")
        .removeClass("selected");

      updateFilter();
      ajaxLoad("filter");
    });

    function updateFilter() {
      var taxonomy = $filter.data("taxonomy");
      filter_str = "";

      $filter.find("a").each(function () {
        var $a = $(this);
        if ($a.hasClass("selected") && $a.data("filter") != "all") {
          filter_str = taxonomy + ":" + $a.data("filter");
        }
      });
    }

    function ajaxLoad(action) {
      if (!pageIsLoading) {
        pageIsLoading = true;

        $container.addClass("loading " + action);
        $paginateNav.addClass("loading " + action);

        var offset =
          action == "paginate" ? $container.find(settings.post).length : 0;

        var data = {
          action: settings.page_action,
          type: settings.post_type,
          template: settings.template,
          offset: offset,
          postsPerPage: postsPerPage,
          filter: filter_str,
        };

        if (action == "filter") {
          $paginateNav.show();
        }

        $.ajax({
          url: glance.ajaxUrl,
          type: "post",
          data: data,
          success: function (result) {
            var $result = $(result);
            var numResults = $result.length;
            var maxPages = $result.first().data("max");
            var hidePaginate =
              numResults < postsPerPage ||
              !(maxPages * postsPerPage > offset + numResults);

            if ($result.filter(".showOnView").length) {
              $result.filter(".showOnView").css("opacity", 0).showOnView();
            }

            if (action == "paginate") {
              $result.appendTo($container);
            } else {
              $container.html($result);
            }

            if (hidePaginate) $paginateNav.hide();
            pageIsLoading = false;
            $container.removeClass("loading " + action);
            $paginateNav.removeClass("loading " + action);

            // if (action == "filter") {
            //   if (filter_str == "") {
            //     window.history.pushState("filter", "Filter", location.pathname);
            //   } else {
            //     var ar = filter_str.split(":");
            //     var term = ar[1];
            //     window.history.pushState(
            //       "filter",
            //       "Filter",
            //       prefix + "/" + term + "/"
            //     );
            //   }
            // }
          },
        });
      }
    }

    // window.addEventListener("popstate", function (event) {
    //   if (event.state == "filter") {
    //     window.location.reload();
    //   }
    // });

    return this;
  };

  // Ajaxs Filter posts
  // ------

  $.fn.ajaxFilter = function (options) {
    var settings = $.extend(
      {
        post_type: "post",
        template: "parts/loop-archive.php",
        page_action: "posts_load",
        post: ".ajax-post",
        posts_per_page: "posts_per_page",
        filter: ".category-filter",
        multi: false,
      },
      options
    );

    var $container = this;
    var pageIsLoading = false;
    var postsPerPage = this.data(settings.posts_per_page);
    var $filter = $(settings.filter);
    var filter_str = "";

    $filter.on("click", "button", function () {
      if (settings.multi) {
        $(this).toggleClass("selected");
      } else {
        $(this).addClass("selected");
        $(this).parent().siblings().find("button").removeClass("selected");
      }

      updateFilter();
      ajaxLoad();
    });

    function updateFilter() {
      var taxonomy = $filter.data("taxonomy");
      var filter = [];
      filter_str = "";

      $filter.find("button").each(function () {
        var $a = $(this);
        if ($a.hasClass("selected") && $a.data("filter") != "all") {
          filter.push($a.data("filter"));
        }
      });

      filter_str = filter.length ? taxonomy + ":" + filter.join(";") : "";
    }

    function ajaxLoad() {
      if (!pageIsLoading) {
        pageIsLoading = true;

        $container.addClass("loading filter");

        var offset = 0;

        // console.log(filter_str);

        var data = {
          action: settings.page_action,
          type: settings.post_type,
          template: settings.template,
          offset: offset,
          postsPerPage: postsPerPage,
          filter: filter_str,
        };

        $.ajax({
          url: glance.ajaxUrl,
          type: "post",
          data: data,
          success: function (result) {
            var $result = $(result);

            if ($result.filter(".showOnView").length) {
              $result.filter(".showOnView").css("opacity", 0).showOnView();
            }

            $container.html($result);

            pageIsLoading = false;
            $container.removeClass("loading filter");
          },
        });
      }
    }

    return this;
  };

  //
  // Filter Toggle
  //

  $.fn.filterToggle = function (options) {
    var settings = $.extend(
      {
        container: ".category-filter-multi",
      },
      options
    );

    var $toggle = this;
    var $container = $(settings.container);

    $toggle.on("click", function () {
      $toggle.toggleClass("selected");
      if ($toggle.hasClass("selected")) {
        $container.addClass("selected");
      } else {
        $container.removeClass("selected");
      }
    });
  };

  //
  // Sticky Block
  //

  $.fn.stickyBlock = function (options) {
    var settings = $.extend({}, options);

    var $window = $(window);
    var $header = $(".site-header");
    var $el = this;
    var $container = $el.parent();
    var $form = $container.closest(".body-two-columns").find(".body-content");
    var offset = $header.outerHeight();
    var breakpoint = 1040;

    $window.on("resize", function () {
      updateStickyBlock();
    });

    $window.on("scroll", function () {
      updateStickyBlock();
    });

    new ResizeSensor($el, function () {
      updateStickyBlock();
    });

    function checkConditions() {
      return (
        $el.is(":visible") &&
        $window.width() > breakpoint &&
        $form.outerHeight() > $el.outerHeight()
      );
    }

    function updateStickyBlock() {
      var ok = checkConditions();
      if (ok) {
        offset = $header.outerHeight();

        if (
          $window.scrollTop() > $form.offset().top - offset &&
          $window.scrollTop() + offset <
            $form.offset().top + ($form.outerHeight() - $el.outerHeight())
        ) {
          $el.attr(
            "style",
            "position: fixed; top:" +
              offset +
              "px; left:" +
              $container.offset().left +
              "px; width:" +
              $container.outerWidth() +
              "px;"
          );
        } else if (
          $window.scrollTop() + offset >=
          $form.offset().top + ($form.outerHeight() - $el.outerHeight())
        ) {
          $el.attr(
            "style",
            "position: absolute; top:" +
              ($form.outerHeight() - $el.outerHeight()) +
              "px;"
          );
        } else {
          $el.attr("style", "");
        }
      } else {
        $el.attr("style", "");
      }
    }
  };

  //
  // Sticky Header
  //

  $.fn.stickyHeader = function () {
    var $window = $(window);
    var $header = $(".site-header");
    var $el = this;
    var $children = this.find(".category-title");
    var $container = $el.next(".thought-categories-list");
    var $content = $container.find(".thought-category");
    var offset = $header.outerHeight();
    var breakpoint = 1200;

    $window.on("resize", function () {
      updateStickyBlock();
    });

    $window.on("scroll", function () {
      updateStickyBlock();
    });

    new ResizeSensor($el, function () {
      updateStickyBlock();
    });

    function getElHeight() {
      var h = 0;
      $children.each(function () {
        if ($(this).outerHeight() > h) {
          h = $(this).outerHeight();
        }
      });
      return h;
    }

    function checkConditions() {
      return (
        $el.is(":visible") &&
        $window.width() > breakpoint &&
        $container.outerHeight() > getElHeight()
      );
    }

    function inView() {
      var len = $content.length;
      while (len--) {
        var $row = $content.eq(len);
        if (isInFocus($row, 0.5)) {
          var $headline = $children.eq(len);
          $headline.prevAll().removeClass("belowView").addClass("aboveView");
          $headline.removeClass("belowView aboveView");
          $headline.nextAll().removeClass("aboveView").addClass("belowView");
          return false;
        }
      }
    }

    function updateStickyBlock() {
      var ok = checkConditions();
      if (ok) {
        offset = $header.outerHeight();

        if (
          $window.scrollTop() > $container.offset().top - offset &&
          $window.scrollTop() + offset <
            $container.offset().top + ($container.outerHeight() - getElHeight())
        ) {
          $el.attr("style", "position: fixed; top:" + offset + "px;");
        } else if (
          $window.scrollTop() + offset >=
          $container.offset().top + ($container.outerHeight() - getElHeight())
        ) {
          $el.attr(
            "style",
            "position: absolute; top:" +
              ($container.outerHeight() - getElHeight()) +
              "px;"
          );
          $children.removeClass("aboveView").addClass("belowView");
          $children.eq($children.length - 1).removeClass("belowView");
        } else {
          $el.attr("style", "");
          $children.removeClass("belowView").addClass("aboveView");
          $children.eq(0).removeClass("aboveView");
        }

        inView();
      } else {
        $el.attr("style", "");
      }
    }

    updateStickyBlock();
  };

  //
  // Sidebar Section Toggle
  //

  $.fn.sidebarSectionToggle = function () {
    this.on("click", function () {
      $(this).parent().toggleClass("active");
    });
  };

  //
  // Popup Form
  //

  $.fn.popupForm = function () {
    var $body = $("body");
    this.on("click", function () {
      var $form = $("#" + $(this).data("form")).length
        ? $("#" + $(this).data("form"))
        : false;
      if ($form) {
        $body.addClass("popup-open");
        $form.find(".bg").velocity("fadeIn", { duration: 300 });
        $form
          .find(".fg")
          .velocity("transition.slideUpIn", { duration: 450, display: "flex" });
        $form
          .find(".icon-close, .bg")
          .off("click")
          .on("click", function (e) {
            e.preventDefault();
            $body.removeClass("popup-open");
            $form.find(".bg").velocity("fadeOut", { duration: 300 });
            $form
              .find(".fg")
              .velocity("transition.slideDownOut", { duration: 450 });
          });
      }
    });
  };

  //
  // Mapbox
  //

  $.fn.mapbox = function () {
    var lat = this.data("lat");
    var lng = this.data("lng");

    mapboxgl.accessToken =
      "pk.eyJ1IjoiZXJpY3BldHoiLCJhIjoiY2w0ZWsxaXN4MDQ5bzNqcW94aHJpamEwdSJ9.OH4PmNcrURm6nhnNPvwX0g";
    var map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/ericpetz/cl4q8yrks000315qsvj7ywnid",
      center: [lng, lat], // starting position
      zoom: 14, // starting zoom
    });

    map.addControl(new mapboxgl.NavigationControl());

    map.on("load", function () {
      map.loadImage(
        glance.templateUrl + "/assets/images/map-marker.png",
        function (error, image) {
          if (error) throw error;
          map.addImage("pin", image);
          map.addSource("point", {
            type: "geojson",
            data: {
              type: "FeatureCollection",
              features: [
                {
                  type: "Feature",
                  geometry: {
                    type: "Point",
                    coordinates: [lng, lat],
                  },
                },
              ],
            },
          });
          map.addLayer({
            id: "points",
            type: "symbol",
            source: "point",
            layout: {
              "icon-image": "pin",
              "icon-size": 0.5,
            },
          });
        }
      );
    });
  };

  // FAQ

  $.fn.faq = function() {
    this.on('click', 'header', function() {
      var $header = $(this);
      var $article = $header.next('article');
      var $faq = $header.closest("li");
      var open = $faq.hasClass('open');
      if (open) {
        $article.velocity("slideUp", { duration: 300, display: "none" });
        $faq.removeClass('open');
      } else {
        $article.velocity("slideDown", { duration: 300, display: "block" });
        $faq.addClass('open');
      }
    });
  }

  // tab highlight siblings

  $.fn.highlightSiblings = function () {
    var $container = this;
    this.find("ul").append('<li id="highlighter"></li>');
    var $highlighter = this.find("#highlighter");
    var $selected = $container.find(".selected");
    var highlighterPadding = 0;

    function positionHighlighter($el) {
      var rightPos = $el.parent().position().left - highlighterPadding;
      var newWidth = $el.outerWidth() + highlighterPadding * 2;

      $highlighter.css({
        left: rightPos,
        width: newWidth,
      });
    }

    positionHighlighter($selected);

    $(window).on("resize.positionhighlighter", function () {
      positionHighlighter($selected);
    });

    this.find("a, button")
      .hover(
        function () {
          var $el = $(this);
          positionHighlighter($el);
        },
        function () {
          positionHighlighter($selected);
        }
      )
      .click(function () {
        $selected = $(this);
      });

    this.on("mouseover", "a, button", function () {
      $container.addClass("active");
    }).on("mouseout", "a, button", function () {
      $container.removeClass("active");
    });
  };

  // Side Form

  $.fn.sideForm = function () {
    var $panel = this;

    this.on("click", ".side-form-tab, .icon-close", function () {
      $panel.toggleClass("active");
    });
  };

  // feature categories

  $.fn.featureCategories = function () {
    var $elements = this;
    var count = 0;

    function inView() {
      count = $elements.length;
      var isinview = false;
      while (count--) {
        var $el = $elements.eq(count);

        if (isInFocus($el, 0.7)) {
          isinview = true;
          $el.prevAll().removeClass("belowView").addClass("aboveView");
          $el.removeClass("belowView aboveView");
          $el.nextAll().removeClass("aboveView").addClass("belowView");
          return false;
        }
      }
      if(!isinview) {
        $elements.addClass("belowView")
      }
    }

    $(window)
      .on("scroll.modulesInView", function () {
        inView();
      })
      .on("resize.modulesInView", function () {
        inView();
      });

    inView();
  };

  // Quote Video

  $.fn.quoteVideo = function (options) {
    var settings = $.extend(
      {
        parent: ".quote",
        toggle: ".video-cta, .video-close",
      },
      options
    );
    var $container = this.closest(settings.parent);
    var $toggle = $container.find(settings.toggle);

    $toggle.on("click", function () {
      $container.toggleClass("playing");
    });
  };

  // Utilities
  // ------

  var aboveFocus = function (element, focusMultipliers) {
    return (
      $(window).scrollTop() >= element.offset().top + element.outerHeight() * focusMultipliers
    );
  };

  var aboveView = function (element) {
    return (
      $(window).scrollTop() >= element.offset().top + element.outerHeight()
    );
  };

  var belowFocus = function (element, focusMultipliers) {
    return (
      $(window).height() + $(window).scrollTop() <
      element.offset().top + $(window).height() * focusMultipliers
    );
  };

  var isInFocus = function (element, focusMultipliers) {
    return (
      aboveView(element) != true &&
      belowFocus(element, focusMultipliers) != true
    );
  };
})(jQuery);
